import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import axios from 'axios'

import HeaderMeta from 'components/HeaderMeta'

import isDebug from 'utils/isDebug'

import Content from 'components/base/Content'
import Img from 'components/base/Img'
import Loading from 'components/base/Loading'
import Title from 'components/base/Title'
import SectionRule from 'components/base/SectionRule/styles'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import FeaturedNews from 'components/blocks/FeaturedNews'
import CompetitiveBenefits from 'components/blocks/CompetitiveBenefits'
import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import Leadership from 'components/blocks/Leadership'
import OurStory from 'components/blocks/OurStory'
import Connect from 'components/blocks/Connect'

import { JobList } from './styles'

const CareersScreen: React.FC = (): React.ReactElement => {
  useEffect(() => {
    axios
      .request({
        baseURL: 'https://insurancelounge.bamboohr.com/',
        url: 'jobs/embed2.php',
      })
      .then(resp => {
        if (resp.data) {
          const eleBambooHRATS = document.getElementById('BambooHR-ATS')
          eleBambooHRATS && (eleBambooHRATS.innerHTML = resp.data)
        }
      })
      .catch(error => {
        isDebug && console.error('BambooHR Error', error.response) // eslint-disable-line no-console
      })
  }, [])

  return (
    <div>
      <HeaderMeta
        title='Careers | Insurance Lounge'
        description='Insurance Lounge career opportunities'
        ogImg='/images/og-images/Careers.webp'
      />
      <Helmet>
        <link
          href='https://insurancelounge.bamboohr.com/css/jobs-embed.css'
          rel='stylesheet'
        />
      </Helmet>

      <PageHero theme={PageHeroTheme.careers}>Careers</PageHero>
      <Content margined={true}>
        <Title level={2}>A Wealth of Opportunity</Title>
        <Paragraph theme={ParagraphTheme.introLarge}>
          Insurance Lounge offers great growth opportunities and competitive
          benefits.
        </Paragraph>
        <Content short={true} center={true}>
          <JobList id='BambooHR'>
            <div id='BambooHR-ATS'>
              <Loading />
            </div>

            <div id='BambooHR-Footer'>
              Powered by
              <a
                href='http://www.bamboohr.com'
                target='_blank'
                rel='noopener external nofollow noreferrer'
              >
                <Img
                  src='https://resources.bamboohr.com/images/footer-logo.webp'
                  src2x={undefined}
                  alt='BambooHR - HR software'
                />
              </a>
            </div>
          </JobList>
        </Content>
        <SectionRule fullWidth={true} />
        <Title level={2} center={true}>
          Competitive Benefits
        </Title>
        <CompetitiveBenefits />
      </Content>
      <OurStory />
      <Leadership />
      <FeaturedNews />
      <Connect
        trackingInfo={{
          button_position: 'bottom',
          page_category: 'about_us',
        }}
      />
    </div>
  )
}

export default CareersScreen
